export const DATE_FORMAT = 'DD-MM-YYYY';

export const BACKEND_DATE_FORMAT = 'YYYY-MM-DD';

export const EXTENDED_DATE_FORMAT = 'YYYY-MM-DD HH:MM:ss';

export const ONE_MINUTE = 60;
